import { PropsWithChildren } from "react";

export type IconWrapperProps = PropsWithChildren<{
  width?: number;
  height?: number;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
  className?: string;
  svgClass?: string;
  style?: React.CSSProperties;
}>;

const IconWrapper = ({
  children,
  width = 24,
  height = width,
  viewBoxWidth = width,
  viewBoxHeight = height,
  style,
  className,
  ...props
}: IconWrapperProps) => {
  const classes = `h-[1em] flex justify-center items-center", ${className}`;

  return (
    <div className={classes} style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        style={{ height: "100%", width: "100%" }}
        {...props}
      >
        {children}
      </svg>
    </div>
  );
};

export default IconWrapper;
